// @ts-check
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { resetPassword } from "../../../redux/auth/actions";
import { Button, Form } from "react-bootstrap";
import { APP_CONST, AuthModals } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import useAuthModalHook from "../../../hooks/useAuthModalHook";

import { IoIosEye, IoIosEyeOff } from "react-icons/io";

const ResetPassword = ({ show }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { updateActiveAuthModal } = useAuthModalHook();
  const [isVerifying, setIsVerifying] = useState(false);
  const [formData, setFormData] = useState({
    otp: "",
    password: "",
  });

  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.otp === "" || formData.password === "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
      return;
    }
    setIsVerifying(true);
    const response = await resetPassword(formData);
    setIsVerifying(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");

      updateActiveAuthModal(AuthModals.Login);
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-register reset"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      ></Modal.Header>
      <Modal.Body>
        <div className="inner-wrapper mb-5">
          <h2 className="title">Enter OTP and Reset Password</h2>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="form-group" controlId="formBasicOTP">
              <Form.Control
                type="text"
                placeholder="Enter OTP*"
                autoComplete="off"
                onChange={(e) =>
                  setFormData((p) => ({ ...p, otp: e.target.value }))
                }
              />
            </Form.Group>
            <Form.Group className="form-group" controlId="formBasicPassword">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                autoComplete="new-password"
                onChange={(e) =>
                  setFormData((p) => ({ ...p, password: e.target.value }))
                }
              />
              <span className="icon" onClick={() => setShowPassword((s) => !s)}>
                {showPassword ? <IoIosEyeOff /> : <IoIosEye />}
              </span>
            </Form.Group>

            <Button variant="primary" disabled={isVerifying} type="submit">
              {!isVerifying ? "Submit" : "Submitting"}
            </Button>
          </Form>

          {/* <div className="signin-signup">
            Already have an account?{" "}
            <a
              onClick={() => {
                updateActiveAuthModal(AuthModals.Login);
              }}
            >
              Log In here
            </a>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ResetPassword;
